import { render, staticRenderFns } from "./BSActionMenu.vue?vue&type=template&id=eb7478ce&scoped=true"
import script from "./BSActionMenu.vue?vue&type=script&lang=js"
export * from "./BSActionMenu.vue?vue&type=script&lang=js"
import style0 from "./BSActionMenu.vue?vue&type=style&index=0&id=eb7478ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb7478ce",
  null
  
)

export default component.exports